<div class="internal-messages-counter">
  {{ _unreadMessages }}
</div>
